// countryBounds.js
// List of country bounding boxes (lat/lng pairs for SW and NE corners)
// Data source: Natural Earth, OpenStreetMap, and public datasets
// Format: { [countryName]: { bounds: [[south, west], [north, east]] } }

const COUNTRY_BOUNDS = {
  Afghanistan: { bounds: [[29.3772, 60.5176], [38.4911, 74.8899]] },
  Albania: { bounds: [[39.624998, 19.263611], [42.661084, 21.057222]] },
  Algeria: { bounds: [[18.976387, -8.667222], [37.093723, 11.997222]] },
  Andorra: { bounds: [[42.428492, 1.413078], [42.655765, 1.786542]] },
  Angola: { bounds: [[-18.0421, 11.6401], [-4.3881, 24.0879]] },
  Argentina: { bounds: [[-55.061, -73.5604], [-21.7812, -53.6375]] },
  Armenia: { bounds: [[38.840477, 43.447139], [41.301834, 46.634222]] },
  Australia: { bounds: [[-43.634597, 113.338953], [-10.668185, 153.569469]] },
  Austria: { bounds: [[46.372276, 9.530952], [49.020608, 17.160776]] },
  Azerbaijan: { bounds: [[38.392955, 44.774113], [41.90564, 50.392821]] },
  Bahamas: { bounds: [[20.908, -78.98], [27.04, -72.67]] },
  Bahrain: { bounds: [[25.796, 50.377], [26.387, 50.850]] },
  Bangladesh: { bounds: [[20.670883, 88.021789], [26.634513, 92.680115]] },
  Barbados: { bounds: [[13.044, -59.653], [13.336, -59.417]] },
  Belarus: { bounds: [[51.256, 23.178], [56.172, 32.762]] },
  Belgium: { bounds: [[49.497, 2.541], [51.505, 6.407]] },
  Belize: { bounds: [[15.885, -89.229], [18.496, -87.309]] },
  Benin: { bounds: [[6.235, 0.772], [12.409, 3.843]] },
  Bhutan: { bounds: [[26.702, 88.746], [28.246, 92.125]] },
  Bolivia: { bounds: [[-22.898, -69.644], [-9.680, -57.453]] },
  Bosnia_and_Herzegovina: { bounds: [[42.546, 15.728], [45.276, 19.623]] },
  Botswana: { bounds: [[-26.907, 19.998], [-17.778, 29.375]] },
  Brazil: { bounds: [[-33.751, -73.990], [5.271, -34.793]] },
  Brunei: { bounds: [[4.002, 114.075], [5.05, 115.363]] },
  Bulgaria: { bounds: [[41.235, 22.357], [44.215, 28.612]] },
  Burkina_Faso: { bounds: [[9.410, -5.513], [15.084, 2.405]] },
  Burundi: { bounds: [[-4.469, 29.024], [-2.309, 30.849]] },
  Cambodia: { bounds: [[10.415, 102.348], [14.704, 107.610]] },
  Cameroon: { bounds: [[1.654, 8.494], [13.083, 16.012]] },
  Canada: { bounds: [[41.676, -141.0], [83.113, -52.636]] },
  Cape_Verde: { bounds: [[14.803, -25.360], [17.205, -22.667]] },
  Central_African_Republic: { bounds: [[2.223, 14.415], [11.142, 27.458]] },
  Chad: { bounds: [[7.442, 13.473], [23.409, 23.886]] },
  Chile: { bounds: [[-55.611, -75.644], [-17.498, -66.959]] },
  China: { bounds: [[18.161, 73.499], [53.560, 134.772]] },
  Colombia: { bounds: [[-4.227, -79.005], [13.394, -66.876]] },
  Comoros: { bounds: [[-12.387, 43.225], [-11.361, 44.529]] },
  Congo: { bounds: [[-5.037, 11.093], [3.713, 18.453]] },
  Costa_Rica: { bounds: [[8.032, -85.941], [11.217, -82.546]] },
  Croatia: { bounds: [[42.393, 13.495], [46.554, 19.447]] },
  Cuba: { bounds: [[19.855, -85.011], [23.276, -74.131]] },
  Cyprus: { bounds: [[34.572, 32.273], [35.173, 34.085]] },
  Czechia: { bounds: [[48.551, 12.090], [51.055, 18.859]] },
  Denmark: { bounds: [[54.559, 8.076], [57.751, 15.041]] },
  Djibouti: { bounds: [[10.926, 41.771], [12.706, 43.419]] },
  Dominica: { bounds: [[15.201, -61.484], [15.633, -61.246]] },
  Dominican_Republic: { bounds: [[17.471, -72.003], [19.936, -68.322]] },
  Ecuador: { bounds: [[-4.959, -92.011], [1.443, -75.192]] },
  Egypt: { bounds: [[21.725, 24.698], [31.585, 35.898]] },
  El_Salvador: { bounds: [[13.149, -90.128], [14.445, -87.693]] },
  Equatorial_Guinea: { bounds: [[1.010, 5.417], [2.340, 11.333]] },
  Eritrea: { bounds: [[12.360, 36.438], [18.003, 43.124]] },
  Estonia: { bounds: [[57.509, 21.832], [59.611, 28.210]] },
  Eswatini: { bounds: [[-27.317, 30.792], [-25.718, 32.134]] },
  Ethiopia: { bounds: [[3.397, 32.954], [14.894, 47.979]] },
  Fiji: { bounds: [[-18.287, 177.129], [-16.020, 180.000]] },
  Finland: { bounds: [[59.846, 20.645], [70.092, 31.586]] },
  France: { bounds: [[41.3, -5.1], [51.1, 9.6]] },
  Gabon: { bounds: [[-3.978, 8.698], [2.318, 14.502]] },
  Gambia: { bounds: [[13.063, -16.841], [13.825, -13.792]] },
  Georgia: { bounds: [[41.054, 40.003], [43.586, 46.736]] },
  Germany: { bounds: [[47.270, 5.866], [55.058, 15.041]] },
  Ghana: { bounds: [[4.738, -3.255], [11.175, 1.199]] },
  Greece: { bounds: [[34.802, 19.373], [41.748, 28.247]] },
  Greenland: { bounds: [[59.777, -73.042], [83.627, -12.208]] },
  Grenada: { bounds: [[11.986, -61.805], [12.536, -61.311]] },
  Guatemala: { bounds: [[13.735, -92.246], [17.819, -88.225]] },
  Guinea: { bounds: [[7.190, -15.082], [12.675, -7.641]] },
  Guinea_Bissau: { bounds: [[11.040, -16.677], [12.686, -13.700]] },
  Guyana: { bounds: [[1.185, -61.410], [8.558, -56.482]] },
  Haiti: { bounds: [[18.021, -74.458], [20.087, -71.624]] },
  Honduras: { bounds: [[12.984, -89.353], [16.005, -83.131]] },
  Hungary: { bounds: [[45.737, 16.113], [48.585, 22.897]] },
  Iceland: { bounds: [[63.393, -24.546], [66.565, -13.495]] },
  India: { bounds: [[6.554, 68.111], [35.674, 97.395]] },
  Indonesia: { bounds: [[-10.359, 95.293], [5.906, 141.033]] },
  Iran: { bounds: [[24.846, 44.032], [39.713, 63.333]] },
  Iraq: { bounds: [[29.099, 38.793], [37.385, 48.634]] },
  Ireland: { bounds: [[51.386, -10.471], [55.381, -5.998]] },
  Israel: { bounds: [[29.5, 34.2], [33.3, 35.9]] },
  Italy: { bounds: [[36.6, 6.6], [47.1, 18.5]] },
  Jamaica: { bounds: [[17.703, -78.366], [18.524, -76.189]] },
  Japan: { bounds: [[24.396, 122.934], [45.552, 153.986]] },
  Jordan: { bounds: [[29.186, 34.957], [33.375, 39.301]] },
  Kazakhstan: { bounds: [[40.568, 46.493], [55.441, 87.315]] },
  Kenya: { bounds: [[-4.678, 33.909], [5.506, 41.899]] },
  Kiribati: { bounds: [[-11.446, -174.543], [4.723, -157.225]] },
  Korea_North: { bounds: [[37.673, 124.265], [43.011, 130.699]] },
  Korea_South: { bounds: [[33.199, 124.609], [38.612, 131.872]] },
  Kuwait: { bounds: [[28.524, 46.553], [30.097, 48.418]] },
  Kyrgyzstan: { bounds: [[39.180, 69.264], [43.266, 80.226]] },
  Laos: { bounds: [[13.915, 100.084], [22.509, 107.635]] },
  Latvia: { bounds: [[55.674, 20.968], [58.084, 28.241]] },
  Lebanon: { bounds: [[33.055, 35.099], [34.692, 36.611]] },
  Lesotho: { bounds: [[-30.675, 27.028], [-28.570, 29.455]] },
  Liberia: { bounds: [[4.353, -11.495], [8.551, -7.369]] },
  Libya: { bounds: [[19.5, 9.32], [33.2, 25.15]] },
  Liechtenstein: { bounds: [[47.048, 9.471], [47.270, 9.635]] },
  Lithuania: { bounds: [[53.896, 21.055], [56.450, 26.835]] },
  Luxembourg: { bounds: [[49.447, 5.735], [50.182, 6.528]] },
  Madagascar: { bounds: [[-25.607, 43.225], [-12.040, 50.484]] },
  Malawi: { bounds: [[-17.129, 32.670], [-9.367, 35.918]] },
  Malaysia: { bounds: [[0.855, 99.640], [7.362, 119.267]] },
  Maldives: { bounds: [[-0.674, 72.693], [7.266, 73.753]] },
  Mali: { bounds: [[10.147, -12.238], [25.001, 4.267]] },
  Malta: { bounds: [[35.799, 14.183], [36.082, 14.567]] },
  Marshall_Islands: { bounds: [[4.573, 165.282], [14.613, 172.029]] },
  Mauritania: { bounds: [[14.721, -17.064], [27.298, -4.833]] },
  Mauritius: { bounds: [[-20.525, 57.307], [-19.982, 63.500]] },
  Mexico: { bounds: [[14.538, -118.455], [32.718, -86.710]] },
  Micronesia: { bounds: [[1.022, 138.204], [10.086, 163.041]] },
  Moldova: { bounds: [[45.467, 26.619], [48.491, 30.135]] },
  Monaco: { bounds: [[43.724, 7.409], [43.751, 7.439]] },
  Mongolia: { bounds: [[41.581, 87.751], [52.149, 119.931]] },
  Montenegro: { bounds: [[41.857, 18.433], [43.558, 20.358]] },
  Morocco: { bounds: [[27.667, -13.262], [35.922, -1.027]] },
  Mozambique: { bounds: [[-26.860, 30.179], [-10.471, 40.846]] },
  Myanmar: { bounds: [[9.784, 92.172], [28.547, 101.170]] },
  Namibia: { bounds: [[-28.969, 11.734], [-16.963, 25.264]] },
  Nauru: { bounds: [[-0.547, 166.909], [-0.502, 166.958]] },
  Nepal: { bounds: [[26.347, 80.058], [30.447, 88.201]] },
  Netherlands: { bounds: [[50.750, 3.358], [53.555, 7.227]] },
  New_Zealand: { bounds: [[-47.286, 166.426], [-34.392, 178.550]] },
  Nicaragua: { bounds: [[10.707, -87.668], [15.033, -83.147]] },
  Niger: { bounds: [[11.693, 0.295], [23.517, 15.996]] },
  Nigeria: { bounds: [[4.272, 2.676], [13.892, 14.678]] },
  North_Macedonia: { bounds: [[40.853, 20.452], [42.373, 22.957]] },
  Norway: { bounds: [[57.759, 4.992], [71.188, 31.293]] },
  Oman: { bounds: [[16.651, 52.000], [26.395, 59.836]] },
  Pakistan: { bounds: [[23.634, 60.872], [37.084, 77.837]] },
  Palau: { bounds: [[2.710, 131.114], [7.748, 134.727]] },
  Panama: { bounds: [[7.220, -83.051], [9.611, -77.175]] },
  Papua_New_Guinea: { bounds: [[-11.634, 141.000], [-1.346, 156.019]] },
  Paraguay: { bounds: [[-27.606, -62.644], [-19.287, -54.258]] },
  Peru: { bounds: [[-18.349, -81.410], [-0.038, -68.652]] },
  Philippines: { bounds: [[4.215, 116.954], [21.321, 126.606]] },
  Poland: { bounds: [[49.003, 14.123], [54.835, 24.145]] },
  Portugal: { bounds: [[36.961, -9.500], [42.154, -6.189]] },
  Qatar: { bounds: [[24.556, 50.752], [26.160, 51.606]] },
  Romania: { bounds: [[43.618, 20.261], [48.265, 29.626]] },
  Russia: { bounds: [[41.185, 19.638], [81.857, 180.000]] },
  Rwanda: { bounds: [[-2.838, 28.861], [-1.047, 30.899]] },
  Saint_Kitts_and_Nevis: { bounds: [[17.083, -62.869], [17.418, -62.538]] },
  Saint_Lucia: { bounds: [[13.707, -61.079], [14.272, -60.885]] },
  Saint_Vincent_and_the_Grenadines: { bounds: [[12.583, -61.459], [13.383, -61.113]] },
  Samoa: { bounds: [[-14.052, -172.779], [-13.238, -171.444]] },
  San_Marino: { bounds: [[43.893, 12.403], [43.992, 12.516]] },
  Sao_Tome_and_Principe: { bounds: [[0.024, 6.470], [1.701, 7.483]] },
  Saudi_Arabia: { bounds: [[16.347, 34.495], [32.161, 55.666]] },
  Senegal: { bounds: [[12.307, -17.528], [16.691, -11.345]] },
  Serbia: { bounds: [[42.232, 18.814], [46.190, 23.006]] },
  Seychelles: { bounds: [[-4.720, 55.454], [-4.283, 56.297]] },
  Sierra_Leone: { bounds: [[6.785, -13.246], [9.999, -10.284]] },
  Singapore: { bounds: [[1.130, 103.605], [1.450, 104.007]] },
  Slovakia: { bounds: [[47.731, 16.833], [49.613, 22.565]] },
  Slovenia: { bounds: [[45.421, 13.375], [46.876, 16.610]] },
  Solomon_Islands: { bounds: [[-10.826, 155.508], [-6.599, 162.398]] },
  Somalia: { bounds: [[-1.683, 40.989], [11.988, 51.413]] },
  South_Africa: { bounds: [[-34.819, 16.344], [-22.126, 32.830]] },
  South_Sudan: { bounds: [[3.488, 23.886], [12.236, 35.948]] },
  Spain: { bounds: [[27.637, -18.167], [43.792, 4.591]] },
  Sri_Lanka: { bounds: [[5.918, 79.652], [9.835, 81.881]] },
  Sudan: { bounds: [[8.684, 21.814], [22.204, 38.613]] },
  Suriname: { bounds: [[1.831, -58.070], [6.011, -53.986]] },
  Sweden: { bounds: [[55.361, 11.027], [69.106, 23.903]] },
  Switzerland: { bounds: [[45.818, 5.956], [47.808, 10.492]] },
  Syria: { bounds: [[32.312, 35.700], [37.318, 42.385]] },
  Taiwan: { bounds: [[21.885, 119.534], [25.295, 122.006]] },
  Tajikistan: { bounds: [[36.671, 67.342], [41.045, 75.153]] },
  Tanzania: { bounds: [[-11.745, 29.341], [-0.985, 40.449]] },
  Thailand: { bounds: [[5.612, 97.344], [20.464, 105.636]] },
  Togo: { bounds: [[6.112, -0.144], [11.139, 1.808]] },
  Tonga: { bounds: [[-21.836, -175.198], [-15.559, -173.907]] },
  Trinidad_and_Tobago: { bounds: [[10.042, -61.925], [11.349, -60.895]] },
  Tunisia: { bounds: [[30.230, 7.524], [37.535, 11.583]] },
  Turkey: { bounds: [[35.813, 25.621], [42.107, 44.793]] },
  Turkmenistan: { bounds: [[35.140, 52.502], [42.797, 66.546]] },
  Tuvalu: { bounds: [[-9.420, 176.071], [-5.642, 179.906]] },
  Uganda: { bounds: [[-1.477, 29.573], [4.234, 35.035]] },
  Ukraine: { bounds: [[44.386, 22.137], [52.379, 40.227]] },
  United_Arab_Emirates: { bounds: [[22.631, 51.579], [26.076, 56.396]] },
  United_Kingdom: { bounds: [[49.959, -8.649], [60.847, 1.768]] },
  United_States: { bounds: [[24.396, -125.000], [49.384, -66.934]] },
  Uruguay: { bounds: [[-34.977, -58.438], [-30.109, -53.209]] },
  Uzbekistan: { bounds: [[37.182, 55.998], [45.590, 73.133]] },
  Vanuatu: { bounds: [[-20.253, 166.525], [-13.072, 167.844]] },
  Vatican_City: { bounds: [[41.900, 12.445], [41.907, 12.458]] },
  Venezuela: { bounds: [[0.647, -73.353], [12.201, -59.805]] },
  Vietnam: { bounds: [[8.195, 102.144], [23.393, 109.464]] },
  Yemen: { bounds: [[12.111, 42.585], [19.000, 54.539]] },
  Zambia: { bounds: [[-17.961, 21.999], [-8.238, 33.701]] },
  Zimbabwe: { bounds: [[-22.424, 25.237], [-15.609, 32.849]] },
};

// Utility: get bounding box for a list of countries (using a static map or a geocoding API)
async function getCountriesBoundingBox(countries, cities) {
  // 1. Try to bound by cities' lat/lng if available
  if (Array.isArray(cities) && cities.length > 0) {
    // Filter cities with valid lat/lng
    const validCities = cities.filter(city =>
      typeof city.lat === "number" && typeof city.lng === "number"
    );
    if (validCities.length > 0) {
      let minLat = 90, minLng = 180, maxLat = -90, maxLng = -180;
      validCities.forEach(city => {
        minLat = Math.min(minLat, city.lat);
        minLng = Math.min(minLng, city.lng);
        maxLat = Math.max(maxLat, city.lat);
        maxLng = Math.max(maxLng, city.lng);
      });
      if (minLat < maxLat && minLng < maxLng) {
        return { bounds: [[minLat, minLng], [maxLat, maxLng]] };
      }
      // If only one city, center on it
      if (validCities.length === 1) {
        return { lat: validCities[0].lat, lng: validCities[0].lng, zoom: 10 };
      }
    }
  }

  // 2. Fallback to country bounds logic (existing)
  if (!countries || countries.length === 0) return null;
  if (countries.length === 1) {
    const c = countries[0];
    if (COUNTRY_BOUNDS[c]) return COUNTRY_BOUNDS[c];
    // fallback: center of country, zoom 6
    return { lat: 0, lng: 0 , zoom: 6 };
  }
  // Multiple countries: merge bounds
  let minLat = 90, minLng = 180, maxLat = -90, maxLng = -180;
  countries.forEach(c => {
    const b = COUNTRY_BOUNDS[c];
    if (b && b.bounds) {
      minLat = Math.min(minLat, b.bounds[0][0]);
      minLng = Math.min(minLng, b.bounds[0][1]);
      maxLat = Math.max(maxLat, b.bounds[1][0]);
      maxLng = Math.max(maxLng, b.bounds[1][1]);
    }
  });
  if (minLat < maxLat && minLng < maxLng) {
    return { bounds: [[minLat, minLng], [maxLat, maxLng]] };
  }
  // fallback: world view
  return { lat: 20, lng: 0, zoom: 2 };
}


export default getCountriesBoundingBox;
